import { styled } from '@mui/system';
import { Button } from '@mui/material';

import { defaultTheme } from '@toolbox/style/theme/common/ThemeProvider/themes/defaultTheme';
import { neutrals, primary } from '@toolbox/style/theme/common/ThemeProvider/colors';

import type { Theme } from '@mui/material';

export const CallbackButton = styled(Button)({
  padding: '11px 24px',
  marginLeft: '16px',
  fontSize: '16px',
  lineHeight: 1,
  fontWeight: 700,
});

export const localCallBackBlockTheme: Theme = {
  ...defaultTheme,
  components: {
    ...defaultTheme.components,
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: primary.main,
          borderRadius: '2px',
          '& fieldset': {
            borderColor: '#D3D4D6',
          },
          '&.active fieldset': {
            borderColor: primary.main,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: primary.main,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
          },
          '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: `${neutrals.lighter}!important`,
          },
          '&.Mui-disabled': {
            background: neutrals.contrastText,
          },
          '&.Mui-focused svg': {
            color: primary.main,
          },
          '& svg': {
            color: neutrals.lighter,
          },
          '&.Mui-disabled svg.Mui-disabled': {
            color: neutrals.lighter,
          },
        },
        input: {
          '&.Mui-disabled': {
            WebkitTextFillColor: neutrals.lighter,
          },
        },
        notchedOutline: {
          border: `1px solid ${neutrals.lighter}`,
        },
      },
    },
  },
};
